const config = {
    CobBucks: [
        {
            name: "Brass",
            id: 1,
            amount: 100,
            image: `${process.env.PUBLIC_URL}/images/Coppercob.png`
        },
        
        {
            name: "Silver",
            id: 2,
            amount: 1,
            image: `${process.env.PUBLIC_URL}/images/Silvercob.png`
        },

        {
            name: "Gold",
            id: 3,
            amount: 0,
            image: `${process.env.PUBLIC_URL}/images/Goldcob.png`
        }
    ]
};

export default config;
